import ProjectCarouselFetcher from '@/components/projects/carousel/ProjectCarouselFetcher';
import { ProjectFilters } from '@/data/services/projectServices';
import { useOutletContext } from 'react-router-dom';
import HackathonGeneral from '../../components/projects/hackathon/HackathonGeneral';
import useHackathon from '@/data/hook/hackathon/useHackathon';
import Observable from '@/utils/observers/ObserverPattern';
import { Project } from '@/models/Project';
import withLeiFelca from '@/components/projects/withLeiFelca';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { LEI_FELCA } from '@/lib/growthbook';
import LoadingView from '../courses/LoadingView';

function ProjectGeneralPage() {
  const { filters } = useOutletContext<{ filters: ProjectFilters }>();
  const { hackathon, isLoading } = useHackathon();
  const isLeiFelca = useFeatureIsOn(LEI_FELCA);

  const defaultFilters = {
    ...filters,
    flagsIdNot: hackathon ? [hackathon?.flagId] : undefined,
  };

  const invalidatesObserver = new Observable<number, Project>();

  if (isLoading) return <LoadingView />;

  return (
    <div className="flex flex-col max-w-full mt-8 gap-8">
      <HackathonGeneral filters={filters} />
      <ConditionalRenderer condition={!isLeiFelca}>
        <ProjectCarouselFetcher
          section="recents"
          invalidatesObserver={invalidatesObserver}
          filters={{ ...defaultFilters }}
        />
        <ProjectCarouselFetcher
          section="highlights"
          invalidatesObserver={invalidatesObserver}
          filters={{ ...defaultFilters, byUpVotes: 'more' }}
        />
        <ProjectCarouselFetcher
          section="viewed"
          invalidatesObserver={invalidatesObserver}
          filters={{ ...defaultFilters, byViews: 'more' }}
        />
      </ConditionalRenderer>
    </div>
  );
}

export default withLeiFelca(ProjectGeneralPage);
